<template>
  <div class="realtime-page">
    <!-- 顶部导航栏 -->
    <div class="header-bar">
      <van-icon name="arrow-left" class="back-icon" @click="goBack" />
      <h1 class="page-title">历史视频</h1>
    </div>

    <div class="content-area">
      <div v-if="videoUrl" class="video-wrapper">
        <video
          ref="videoPlayer"
          :src="videoUrl"
          controls
          autoplay
          loop
          playsinline
          webkit-playsinline
          preload="auto"
          class="video-player"
        ></video>
      </div>
      <div v-else class="empty-content">
        <van-empty :description="emptyMessage" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RealTimeView",
  data() {
    return {
      videoUrl:
        "https://morehealthy.oss-cn-beijing.aliyuncs.com/cunchuguan/cunchuguan.mp4",
    };
  },
  mounted() {
    // 确保视频自动播放并打开声音
    this.$nextTick(() => {
      const video = this.$refs.videoPlayer;
      if (video) {
        // 设置音量为最大（默认有声音）
        video.volume = 1;
        video.muted = false;

        // 尝试播放视频
        video.play().catch((error) => {
          console.log("自动播放失败，可能需要用户交互", error);
          // 如果自动播放失败（浏览器策略限制），尝试静音播放后再取消静音
          video.muted = true;
          video
            .play()
            .then(() => {
              // 播放成功后，取消静音
              video.muted = false;
            })
            .catch((err) => {
              console.log("静音自动播放也失败", err);
            });
        });
      }
    });
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    emptyMessage() {
      return "暂无视频内容";
    },
  },
};
</script>

<style scoped>
.realtime-page {
  min-height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
}

/* 顶部导航栏 */
.header-bar {
  position: sticky;
  top: 0;
  z-index: 100;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.back-icon {
  position: absolute;
  left: 16px;
  font-size: 20px;
  color: #333;
  cursor: pointer;
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0;
}

.content-area {
  flex: 1;
  /* padding: 20px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.video-wrapper {
  width: 100%;
  max-width: 360px;
}

.video-player {
  width: 100%;
  background: #000;
}

/* 空状态内容 */
.empty-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
</style>
